import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageService } from '../../services/page.service';



@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class PageComponent implements OnInit {

  pageLayout:Map<String,any>;
  pages: String[] = [];
  device!: string;

  constructor(private _pageService: PageService, private _route: ActivatedRoute, private router: Router) {
    this.device = (window as any).appSettings.deviceType;
    if(localStorage.getItem("urlBefore404") === null || localStorage.getItem("urlBefore404") === "")
    localStorage.setItem("urlBefore404", "nxi/overview");
  }


  ngOnInit(): void {
    // handle route changes
    this._route.url.subscribe(params => {
      this.pageLayout = new Map();
      if(params.length > 0 && params.length <= 2){
        let page: string = params.length === 1 ? params[0].path : params[params.length - 1].path
        this.pageLayout.set(page, this.getPageLayout(page, false))
        document.getElementsByTagName('main')[0]?.scrollIntoView({ behavior: 'smooth' });
      }else if(params.length > 0) {
        this.pageLayout = this.getDynamicPageLayout(params)
      } else {
        this.pageLayout.set("default", this.getPageLayout("default", false));
      }

      // handle prelogin page, user landing on invalid url
      if (Array.from(this.pageLayout.values()).every(e => e === undefined)) {
        location.href = '/'; // simply refresh the page
      }
      // if current page is a 404, then redirect, else current page will become urlBefore404; only work for post login
      if ( this.isNotFound(this.pageLayout) ) {
        this.router.navigate(['nxi/page-not-found']);
        return;
      }

      localStorage.setItem("urlBefore404", this.router.url);
      this.pages = Array.from(this.pageLayout.keys());
    });
  }
  /**
   * This is only for postlogin where we show /page-not-found and let user to go back to go to overview screen
   * @param pageLayout 
   * @returns 
   */
  isNotFound(pageLayout: Map<any, any>) {
    if(pageLayout == null || pageLayout.size == 0)return true;
    // if LAST path is ERROR or EMPTY, that means the required page D.N.E
    let answer = false;
    for(let value of pageLayout.values()){
      if(value == '' || value[0].name == "ErrorComponent"){
        answer = true;
      }
      else answer = false;
    }
    return answer;
  }
  getDynamicPageLayout(params: any) { //This combines multiple layouts from config to construct the full page for pages in the research pages. This is to prevent repeating large numbers of layouts for 3rd and 4th level pages.
    let researchPageLayoutMap: Map<String,any> = new Map();
    for (let i = 2; i < params.length; i++) {
      let pageValue = params[i].path;
      let pageLayoutItems = this.getPageLayout(pageValue,true);
      researchPageLayoutMap.set(pageValue, pageLayoutItems);
    }
    return researchPageLayoutMap;
  }

  getPageLayout(pageName: string, isDynamicPageLayout: boolean): Array<any> {

    let pageLayout = this._pageService.getLayout('default')["desktop"]; //assume the default layout
    let layout = this._pageService.getLayout(pageName);  // layout returns empty string if no layout.   
    if(!!layout){
      pageLayout = layout[this.device] ? layout[this.device] : layout["desktop"]; //use the device specific layout if it exists, otherwise use desktop
    }else if(isDynamicPageLayout){
      pageLayout = "";
    }

    if(!!pageLayout){
        pageLayout.forEach(element => {
      element = this.processElement(element);
    });
    }


    return pageLayout;

  }

  processElement(element: any) {

    if (!element.type) {
      element.type = "mfe";
    }

    if (!element.start) {
      element.start = 1;
    }

    if (!element.end) {
      element.end = 13;
    }

    if (element.names) {
      element.names.forEach(subElement => {
        if (!subElement.type) {
          subElement.type = "mfe"
        }

        if (!subElement.start) {
          subElement.start = 1;
        }

        if (!subElement.end) {
          subElement.end = 13;
        }
      })
    }

    return element;
  }

}
